<template>
  <div>
    <div class="container">
      <div>
        <h3 class="text-center c-orange text-uppercase mt-3 mb-1">
          Menor Preço
        </h3>
        <p class="text-center mb-5">
          Destaque-se no mercado e aumente suas vendas!
        </p>
      </div>
      <!-- <button @click="returnShopkeeperData()">Pegar dados</button> -->
      <div>
        <h4 class="text-center text-uppercase mt-3 mb-3">
          Escolha os segmentos abaixo
        </h4>
      </div>
      <b-tabs content-class="mt-3" fill>
        <!-- BASICO -->
        <b-tab active>
          <template #title>
            <strong><i class="fas fa-hammer mr-3"></i>BÁSICO</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - Básico
            </h3>
            <div class="row">
              <!-- CARD 01 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/1.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cimento CP III - 50KG - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[1]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                      
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[1]"
                        ref="precodata1"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a 
                      @click="selectItem(1), submitLowestPrice(1)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->

              <!-- CARD 02 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/2.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cimento CP II - 50KG - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[2]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[2]"
                        ref="precodata2"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(2), submitLowestPrice(2)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 02 -->

              <!-- CARD 03 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/3.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cal hidratado CH3 - 20kg - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[3]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[3]"
                        ref="precodata3"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(3), submitLowestPrice(3)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 03 -->

              <!-- CARD 04 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/4.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Areia média grossa mt³
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[4]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[4]"
                        type="tel"
                        ref="precodata4"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(4), submitLowestPrice(4)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 04 -->

              <!-- CARD 05 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/5.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Areia fina mt³
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[5]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[5]"
                        ref="precodata5"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(5), submitLowestPrice(5)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 05 -->

              <!-- CARD 06 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/6.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Areia média mt³
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[6]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[6]"
                        ref="precodata6"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(6), submitLowestPrice(6)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 06 -->

              <!-- CARD 07 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/7.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Pedra britada mt³
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[7]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[7]"
                        ref="precodata7"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(7), submitLowestPrice(7)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 07 -->

              <!-- CARD 08 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/8.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tijolo comum - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[8]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[8]"
                        ref="precodata8"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(8), submitLowestPrice(8)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 08 -->

              <!-- CARD 09 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/9.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tijolo Baiano 8 furos 09x19x19 - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[9]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[9]"
                        ref="precodata9"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(9), submitLowestPrice(9)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 09 -->

              <!-- CARD 10 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/basico/10.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tijolo baiano 9 furos 11,5x14x24 - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[10]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[10]"
                        ref="precodata10"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(10), submitLowestPrice(10)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 10 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>

        <!-- ELETRICA -->
        <b-tab>
          <template #title>
            <strong><i class="fas fa-bolt mr-3"></i>ELETRICA</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - ELETRICO
            </h3>
            <div class="row">
              <!-- Card 01 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/1.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo corrugado 3/4" PVC amarelo - MT
                    </h4>
                    <br>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[11]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[11]"
                        ref="precodata11"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(11), submitLowestPrice(11)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->

              <!-- Card 02 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/2.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo corrugado 1" PVC amarelo - MT
                    </h4>
                    <br>
                    <br>
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[12]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[12]"
                        ref="precodata12"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(12), submitLowestPrice(12)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 02 -->

              <!-- Card 03 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/3.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange adjust">
                      Tubo corrugado PEAD 3/4" preto com guia poliplástico - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[13]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[13]"
                        ref="precodata13"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(13), submitLowestPrice(13)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 03 -->

              <!-- Card 04 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/4.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center adjust">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo corrugado PEAD 1" preto com guia poliplástico - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[14]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[14]"
                        ref="precodata14"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(14), submitLowestPrice(14)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 04 -->

              <!-- Card 05 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/5.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cabo flexível 10,00mm 750v - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[15]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[15]"
                        ref="precodata15"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(15), submitLowestPrice(15)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 05 -->

              <!-- Card 06 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/6.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cabo fléxivel 2,50mm 750v - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[16]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[16]"
                        ref="precodata16"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(16), submitLowestPrice(16)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 06 -->

              <!-- Card 07 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/7.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cabo fléxivel 1,50mm 750v - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[17]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[17]"
                        ref="precodata17"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(17), submitLowestPrice(17)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 07 -->

              <!-- Card 08 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/8.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cabo fléxivel 6,00mm 750v - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[18]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[18]"
                        ref="precodata18"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(18), submitLowestPrice(18)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 08 -->

              <!-- Card 09 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/9.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cabo fléxivel 4,00mm 750v - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[19]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[19]"
                        ref="precodata19"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(19), submitLowestPrice(19)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 09 -->

              <!-- Card 10 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem; height: 30rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/eletrico/10.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Cabo fléxivel 16,00mm 750v - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[20]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[20]"
                        ref="precodata20"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(20), submitLowestPrice(20)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 10 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>

        <!-- HIDRAULICA -->
        <b-tab>
          <template #title>
            <strong><i class="fas fa-shower mr-3"></i>HIDRÁULICA</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - HIDRÁULICA
            </h3>
            <div class="row">
              <!-- Card 01 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/1.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo marrom 25mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[21]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[21]"
                        ref="precodata21"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(21), submitLowestPrice(21)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->

              <!-- Card 02 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/2.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo marrom 50mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[22]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[22]"
                        ref="precodata22"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(22), submitLowestPrice(22)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 02 -->

              <!-- Card 03 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/3.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo marrom 32mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[23]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[23]"
                        ref="precodata23"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(23), submitLowestPrice(23)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 03 -->

              <!-- Card 04 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/4.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo esgoto 40mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[24]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[24]"
                        ref="precodata24"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(24), submitLowestPrice(24)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 04 -->

              <!-- Card 05 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/5.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo esgoto 50mm - MT
                    </h4>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[25]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[25]"
                        ref="precodata25"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(25), submitLowestPrice(25)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 05 -->

              <!-- Card 06 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/6.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo esgoto 75mm - MT
                    </h4>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[26]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[26]"
                        ref="precodata26"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(26), submitLowestPrice(26)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 06 -->

              <!-- Card 07 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/7.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo esgoto 100mm - MT
                    </h4>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[27]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[27]"
                        ref="precodata27"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(27), submitLowestPrice(27)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 07 -->

              <!-- Card 08 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/8.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo polietileno liso 1/2" x 1,50mm - MT
                    </h4>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[28]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata28"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[28]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(28), submitLowestPrice(28)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 08 -->

              <!-- Card 09 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/9.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo polietileno liso 3/4" x 2,00mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[29]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata29"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[29]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(29), submitLowestPrice(29)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 09 -->

              <!-- Card 10 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/hidraulico/10.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Tubo polietileno liso 1" x 2,50mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[30]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata30"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[30]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(30), submitLowestPrice(30)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 10 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>

        <!-- FERRAGENS -->
        <b-tab>
          <template #title>
            <strong><i class="fab fa-uniregistry mr-3"></i>FERRAGENS</strong>
          </template>
          <div class="col">
            <h3
              class="text-center c-orange text-uppercase font-weight-bold mb-4"
            >
              Segmento - Ferragens
            </h3>
            <div class="row">
              <!-- Card 01 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/1.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Barra de ferro 1/4" 6,3mm - MT 
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[31]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata31"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[31]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(31), submitLowestPrice(31)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 01 -->

              <!-- Card 02 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/2.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Barra de ferro 5/16" 8,0mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[32]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata32"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[32]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(32), submitLowestPrice(32)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 02 -->

              <!-- Card 03 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/3.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Barra de ferro 3/8" 10,0mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[33]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata33"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[33]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(33), submitLowestPrice(33)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 03 -->

              <!-- Card 04 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/4.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Arame recozido N.18 torcido - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[34]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="form-control input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata34"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[34]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(34), submitLowestPrice(34)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 04 -->

              <!-- Card 05 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/5.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Treliça para lajes 6,0x3,2x3,4mm - MT
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[35]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata35"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[35]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(35), submitLowestPrice(35)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 05 -->

              <!-- Card 06 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/6.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Estribo U 08x15 4,2mm - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[36]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata36"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[36]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(36), submitLowestPrice(36)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 06 -->

              <!-- Card 07 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/7.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Estribo U 10x20 4,2mm - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[37]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata37"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[37]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(37), submitLowestPrice(37)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 07 -->

              <!-- Card 08 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/8.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange adjust2">
                      Estribo U 15x15 4,2mm - UN
                    </h4>
                    <br>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[38]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata38"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[38]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(38), submitLowestPrice(38)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 08 -->

              <!-- Card 09 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/9.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange">
                      Estribo U 15x27 4,2mm - UN
                    </h4>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[39]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata39"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[39]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(39), submitLowestPrice(39)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 09 -->

              <!-- Card 10 -->
              <div class="mr-2 mb-2">
                <div
                  class="card shadow bg-white rounded py-3 align-items-center"
                  style="width: 16rem"
                >
                  <img
                    class="card-img-top"
                    src="@/assets/img/segmentos/ferragens/10.png"
                    alt="cimento"
                    style="width: 8rem"
                  />

                  <div class="card-body text-center">
                    <h4 class="card-title text-uppercase c-orange adjust2">
                      Estribo U 17x25 4,2mm - UN
                    </h4>
                    <br>
                    <br>
                    
                    <!-- <div class="mb-2 mt-2">
                      <v-select
                        v-model="mrc[40]"
                        taggable
                        class="m-0-auto-right"
                        ref="selectBrand"
                        placeholder="Escolha ou digite a marca"
                        label="nome"
                        :options="produtoMarcas"
                      >
                      </v-select>
                    </div> -->

                    <span class="card-text text-uppercase">Digite o Preço</span>
                    <div class="input-group mb-2 mt-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                      </div>
                      <input
                        ref="precodata40"
                        v-mask="['####,##', '###,##','##,##','#,##']"
                        v-model="preco_data[40]"
                        type="tel"
                        class="form-control"
                        placeholder="Digite o Valor"
                        aria-label="Username"
                        aria-describedby="price"
                      />
                    </div>
                    <a
                      @click="selectItem(40), submitLowestPrice(40)"
                      class="btn btn-success text-uppercase mt-2"
                      >Salvar</a
                    >
                  </div>
                </div>
              </div>
              <!-- Fim card 10 -->
            </div>
            <!-- Fim row -->
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import makeToast from '../../mixins/makeToast';
import { mapState, mapGetters } from 'vuex';
export default {
  mixins: [makeToast],
  data() {
    return {
      mrc: [],
      preco_data: [],
      produto: '',
      unidade: '',
      segmento: '',
      img: '',
    };
  },
  created() {
    this.$store.dispatch('loadProdutoMarcas');
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState(['produtoMarcas']),
  },
  mounted() {
    this.getSavedPrice();
  },
  methods: {
    getSavedPrice() {
      let data = JSON.parse(localStorage.getItem('dadosUsuario'));
      let id = data.id;
      this.$store.dispatch('getShopkeeperPrice', id).then((resposta) => {
          if (!resposta.data[1].preco) {
            this.makeToast('warning', "sem valores salvos", 'warning');
            return;
          }
            resposta.data.forEach(element => {
              if(element.produtos == 'Cimento CP III - 50KG - UN') {
                  this.preco_data[1] = element.preco;
                  this.$refs.precodata1.value = this.preco_data[1];
                  console.log(this.preco_data[1]);
                }
                
                if(element.produtos == 'Cimento CP II - 50KG - UN') {
                  this.preco_data[2] = element.preco;
                  this.$refs.precodata2.value = this.preco_data[2];
                }

                if( element.produtos == 'Cal hidratado CH3 - 20kg - UN') {
                  this.preco_data[3] = element.preco;
                  this.$refs.precodata3.value = this.preco_data[3];
                }

                if( element.produtos == 'Areia média grossa mt³') {
                  this.preco_data[4] = element.preco;
                  this.$refs.precodata4.value = this.preco_data[4];
                }

                if( element.produtos == 'Areia fina mt³') {
                  this.preco_data[5] = element.preco;
                  this.$refs.precodata5.value = this.preco_data[5];
                }

                if( element.produtos == 'Areia média mt³') {
                  this.preco_data[6] = element.preco;
                  this.$refs.precodata6.value = this.preco_data[6];
                }

                if( element.produtos == 'Pedra britada mt³') {
                  this.preco_data[7] = element.preco;
                  this.$refs.precodata7.value = this.preco_data[7];
                }

                if( element.produtos == 'Tijolo comum - UN') {
                this.preco_data[8] = element.preco;
                this.$refs.precodata8.value = this.preco_data[8];
                }

                if( element.produtos == 'Tijolo Baiano 8 furos 09x19x19 - UN') {
                this.preco_data[9] = element.preco;
                this.$refs.precodata9.value = this.preco_data[9];
                }

                if( element.produtos == 'Tijolo baiano 9 furos 11,5x14x24 - UN') {
                this.preco_data[10] = element.preco;
                this.$refs.precodata10.value = this.preco_data[10];
                }

                if( element.produtos == 'Tubo corrugado 3/4" PVC amarelo - MT') {
                this.preco_data[11] = element.preco;
                this.$refs.precodata11.value = this.preco_data[11];
                }

                if( element.produtos == 'Tubo corrugado 1" PVC amarelo - MT') {
                this.preco_data[12] = element.preco;
                this.$refs.precodata12.value = this.preco_data[12];
                }

                if( element.produtos == 'Tubo corrugado PEAD 3/4" preto com guia poliplástico - MT') {
                this.preco_data[13] = element.preco;
                this.$refs.precodata13.value = this.preco_data[13];
                }

                if( element.produtos == 'Tubo corrugado PEAD 1" preto com guia poliplástico - MT') {
                this.preco_data[14] = element.preco;
                this.$refs.precodata14.value = this.preco_data[14];
                }

                if( element.produtos == 'Cabo flexível 10,00mm 750v - MT') {
                this.preco_data[15] = element.preco;
                this.$refs.precodata15.value = this.preco_data[15];
                }

                if( element.produtos == 'Cabo fléxivel 2,50mm 750v - MT') {
                this.preco_data[16] = element.preco;
                this.$refs.precodata16.value = this.preco_data[16];
                }

                if( element.produtos == 'Cabo fléxivel 1,50mm 750v - MT') {
                this.preco_data[17] = element.preco;
                this.$refs.precodata17.value = this.preco_data[17];
                }

                if( element.produtos == 'Cabo fléxivel 6,00mm 750v - MT') {
                this.preco_data[18] = element.preco;
                this.$refs.precodata18.value = this.preco_data[18];
                }

                if( element.produtos == 'Cabo fléxivel 4,00mm 750v - MT') {
                this.preco_data[19] = element.preco;
                this.$refs.precodata19.value = this.preco_data[19];
                }

                if( element.produtos == 'Cabo fléxivel 16,00mm 750v - MT') {
                this.preco_data[20] = element.preco;
                this.$refs.precodata20.value = this.preco_data[20];
                }

                if( element.produtos == 'Tubo marrom 25mm - MT') {
                this.preco_data[21] = element.preco;
                this.$refs.precodata21.value = this.preco_data[21];
                }

                if( element.produtos == 'Tubo marrom 50mm - MT') {
                this.preco_data[22] = element.preco;
                this.$refs.precodata22.value = this.preco_data[22];
                }

                if( element.produtos == 'Tubo marrom 32mm - MT') {
                this.preco_data[23] = element.preco;
                this.$refs.precodata23.value = this.preco_data[23];
                }

                if( element.produtos == 'Tubo esgoto 40mm - MT') {
                this.preco_data[24] = element.preco;
                this.$refs.precodata24.value = this.preco_data[24];
                }

                if( element.produtos == 'Tubo esgoto 50mm - MT') {
                this.preco_data[25] = element.preco;
                this.$refs.precodata25.value = this.preco_data[25];
                }

                if( element.produtos == 'Tubo esgoto 75mm - MT') {
                this.preco_data[26] = element.preco;
                this.$refs.precodata26.value = this.preco_data[2];
                }

                if( element.produtos == 'Tubo esgoto 100mm - MT') {
                this.preco_data[27] = element.preco;
                this.$refs.precodata2.value = this.preco_data[27];
                }

                if( element.produtos == 'Tubo polietileno liso 1/2" x 1,50mm - MT') {
                this.preco_data[28] = element.preco;
                this.$refs.precodata28.value = this.preco_data[28];
                }

                if( element.produtos == 'Tubo polietileno liso 3/4" x 2,00mm - MT') {
                this.preco_data[29] = element.preco;
                this.$refs.precodata29.value = this.preco_data[29];
                }

                if( element.produtos == 'Tubo polietileno liso 1" x 2,50mm - MT') {
                this.preco_data[30] = element.preco;
                this.$refs.precodata30.value = this.preco_data[30];
                }

                if( element.produtos == 'Barra de ferro 1/4" 6,3mm - MT') {
                this.preco_data[31] = element.preco;
                this.$refs.precodata31.value = this.preco_data[31];
                }

                if( element.produtos == 'Barra de ferro 5/16" 8,0mm - MT') {
                this.preco_data[32] = element.preco;
                this.$refs.precodata32.value = this.preco_data[32];
                }

                if( element.produtos == 'Barra de ferro 3/8" 10,0mm - MT') {
                this.preco_data[33] = element.preco;
                this.$refs.precodata33.value = this.preco_data[33];
                }

                if( element.produtos == 'Arame recozido N.18 torcido - MT') {
                this.preco_data[34] = element.preco;
                this.$refs.precodata34.value = this.preco_data[34];
                }

                if( element.produtos == 'Treliça para lajes 6,0x3,2x3,4mm - MT') {
                this.preco_data[35] = element.preco;
                this.$refs.precodata35.value = this.preco_data[35];
                }

                if( element.produtos == 'Estribo U 08x15 4,2mm - UN') {
                this.preco_data[36] = element.preco;
                this.$refs.precodata36.value = this.preco_data[36];
                }

                if( element.produtos == 'Estribo U 10x20 4,2mm - UN') {
                this.preco_data[37] = element.preco;
                this.$refs.precodata37.value = this.preco_data[37];
                }

                if( element.produtos == 'Estribo U 15x15 4,2mm - UN') {
                this.preco_data[38] = element.preco;
                this.$refs.precodata38.value = this.preco_data[38];
                }

                if( element.produtos == 'Estribo U 15x27 4,2mm - UN') {
                this.preco_data[39] = element.preco;
                this.$refs.precodata39.value = this.preco_data[39];
                }

                if( element.produtos == 'Estribo U 17x25 4,2mm - UN') {
                this.preco_data[40] = element.preco;
                this.$refs.precodata40.value = this.preco_data[40];
                }
          });
      });
    },
    submitLowestPrice(n) {
      const user = JSON.parse(localStorage.getItem('dadosUsuario'));
      let dotFormat = this.preco_data[n].replace(',','.');
      let precoFormat = parseFloat(dotFormat)
      
      const data = {
        id_lojista: user.id,
        marca: "construp",
        produtos: this.produto,
        cidade: user.informacoes.cidade.nome,
        preco: precoFormat,
        unidade: this.unidade,
        segmento: this.segmento,
        img: this.img,
      };

      if (!this.validateFields(n)) {
        this.makeToast(
          'Oopss!',
          'Parece que há campos não preenchidos! Corrija-os e tente novamente',
          'danger'
        );
        return;
      } else {
        this.$store.dispatch('insertShopkeeperPrice', data).then((res) => {
          if (res.data.error == 'false') {
            this.makeToast('Sucesso', res.data.message, 'success');
          }
          if (res.data.error == 'true') {
            this.makeToast('Sucesso!', res.data.message, 'success');
          }
        });
      }
    },
    validateFields(n) {
      let isValid = true;

      // if (!this.mrc[n]) {
      //    this.errorMessagesQuote.city = "Você não selecionou a marca";
      //   console.log('sem marca');
      //   isValid = false;
      // }

      if (!this.preco_data[n]) {
        // this.errorMessagesQuote.segment = "Você não inseriu nenhum valor";
        console.log('sem valor');
        isValid = false;
      }
      return isValid;
    },

    selectItem(n) {
      if (n == 1) {
        this.produto = 'Cimento CP III - 50KG - UN';
        this.segmento = 'Basico';
        this.unidade = 'Unidade';
        this.img = '1.png';
      }
      if (n == 2) {
        this.produto = 'Cimento CP II - 50KG - UN';
        this.segmento = 'Basico';
        this.unidade = 'Unidade';
        this.img = '2.png';
      }
      if (n == 3) {
        this.produto = 'Cal hidratado CH3 - 20kg - UN';
        this.segmento = 'Basico';
        this.unidade = 'Unidade';
        this.img = '3.png';
      }
      if (n == 4) {
        this.produto = 'Areia média grossa mt³';
        this.segmento = 'Básico';
        this.unidade = 'mt³';
        this.img = '4.png';
      }
      if (n == 5) {
        this.produto = 'Areia fina mt³';
        this.segmento = 'Básico';
        this.unidade = 'mt³';
        this.img = '5.png';
      }
      if (n == 6) {
        this.produto = 'Areia média mt³';
        this.segmento = 'Básico';
        this.unidade = 'mt³';
        this.img = '6.png';
      }
      if (n == 7) {
        this.produto = 'Pedra britada mt³';
        this.segmento = 'Básico';
        this.unidade = 'mt³';
        this.img = '7.png';
      }
      if (n == 8) {
        this.produto = 'Tijolo comum - UN';
        this.segmento = 'Básico';
        this.unidade = 'Unidade';
        this.img = '8.png';
      }
      if (n == 9) {
        this.produto = 'Tijolo Baiano 8 furos 09x19x19 - UN';
        this.segmento = 'Básico';
        this.unidade = 'Unidade';
        this.img = '9.png';
      }
      if (n == 10) {
        this.produto = 'Tijolo baiano 9 furos 11,5x14x24 - UN';
        this.segmento = 'Básico';
        this.unidade = 'Unidade';
        this.img = '10.png';
      }
      if (n == 11) {
        this.produto = 'Tubo corrugado 3/4" PVC amarelo - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '1.png';
      }
      if (n == 12) {
        this.produto = 'Tubo corrugado 1" PVC amarelo - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '2.png';
      }
      if (n == 13) {
        this.produto = 'Tubo corrugado PEAD 3/4" preto com guia poliplástico - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '3.png';
      }
      if (n == 14) {
        this.produto = 'Tubo corrugado PEAD 1" preto com guia poliplástico - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '4.png';
      }
      if (n == 15) {
        this.produto = 'Cabo flexível 10,00mm 750v - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Unidade';
        this.img = '5.png';
      }
      if (n == 16) {
        this.produto = 'Cabo fléxivel 2,50mm 750v - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '6.png';
      }
      if (n == 17) {
        this.produto = 'Cabo fléxivel 1,50mm 750v - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '7.png';
      }
      if (n == 18) {
        this.produto = 'Cabo fléxivel 6,00mm 750v - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '8.png';
      }
      if (n == 19) {
        this.produto = 'Cabo fléxivel 4,00mm 750v - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '9.png';
      }
      if (n == 20) {
        this.produto = 'Cabo fléxivel 16,00mm 750v - MT';
        this.segmento = 'Eletrica';
        this.unidade = 'Metro';
        this.img = '10.png';
      }
      if (n == 21) {
        this.produto = 'Tubo marrom 25mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '1.png';
      }
      if (n == 22) {
        this.produto = 'Tubo marrom 50mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '2.png';
      }
      if (n == 23) {
        this.produto = 'Tubo marrom 32mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '3.png';
      }
      if (n == 24) {
        this.produto = 'Tubo esgoto 40mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '4.png';
      }
      if (n == 25) {
        this.produto = 'Tubo esgoto 50mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '5.png';
      }
      if (n == 26) {
        this.produto = 'Tubo esgoto 75mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '6.png';
      }
      if (n == 27) {
        this.produto = 'Tubo esgoto 100mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '7.png';
      }
      if (n == 28) {
        this.produto = 'Tubo polietileno liso 1/2" x 1,50mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '8.png';
      }
      if (n == 29) {
        this.produto = 'Tubo polietileno liso 3/4" x 2,00mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '9.png';
      }
      if (n == 30) {
        this.produto = 'Tubo polietileno liso 1" x 2,50mm - MT';
        this.segmento = 'Hidraulica';
        this.unidade = 'Metro';
        this.img = '10.png';
      }
      if (n == 31) {
        this.produto = 'Barra de ferro 1/4" 6,3mm - MT';
        this.segmento = 'Ferragens';
        this.unidade = 'Metro';
        this.img = '1.png';
      }
      if (n == 32) {
        this.produto = 'Barra de ferro 5/16" 8,0mm - MT';
        this.segmento = 'Ferragens';
        this.unidade = 'Metro';
        this.img = '2.png';
      }
      if (n == 33) {
        this.produto = 'Barra de ferro 3/8" 10,0mm - MT';
        this.segmento = 'Ferragens';
        this.unidade = 'Metro';
        this.img = '3.png';
      }
      if (n == 34) {
        this.produto = 'Arame recozido N.18 torcido - MT';
        this.segmento = 'Ferragens';
        this.unidade = 'KG';
        this.img = '4.png';
      }
      if (n == 35) {
        this.produto = 'Treliça para lajes 6,0x3,2x3,4mm - MT';
        this.segmento = 'Ferragens';
        this.unidade = 'Metro';
        this.img = '5.png';
      }
      if (n == 36) {
        this.produto = 'Estribo U 08x15 4,2mm - UN';
        this.segmento = 'Ferragens';
        this.unidade = 'Unidade';
        this.img = '6.png';
      }
      if (n == 37) {
        this.produto = 'Estribo U 10x20 4,2mm - UN';
        this.segmento = 'Ferragens';
        this.unidade = 'Unidade';
        this.img = '7.png';
      }
      if (n == 38) {
        this.produto = 'Estribo U 15x15 4,2mm - UN';
        this.segmento = 'Ferragens';
        this.unidade = 'Unidade';
        this.img = '8.png';
      }
      if (n == 39) {
        this.produto = 'Estribo U 15x27 4,2mm - UN';
        this.segmento = 'Ferragens';
        this.unidade = 'Unidade';
        this.img = '9.png';
      }
      if (n == 40) {
        this.produto = 'Estribo U 17x25 4,2mm - UN';
        this.segmento = 'Ferragens';
        this.unidade = 'Unidade';
        this.img = '10.png';
      }
    },
  },
};
</script>

<style scoped>
h5 {
  font-size: clamp (1.75em, 1em +3wv, 2.5em);
}
.adjust{
  margin-top: 10px;
}
.adjust2{
margin-top: -5px;
}
</style>
